/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Processing_LabelInputs */



/**
* | output |
* | --- |
* | "Processing..." |
*
* @param {Embed_Captions_Processing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_processing_label = /** @type {((inputs?: Embed_Captions_Processing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Processing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitung...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tratamiento...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加工...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रक्रिया जारी है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Processamento...")
	return /** @type {LocalizedString} */ ("Processing...")
});